import { render } from "./ProjectAnalysisTextTheme.vue?vue&type=template&id=058edbc4&scoped=true"
import script from "./ProjectAnalysisTextTheme.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisTextTheme.vue?vue&type=script&lang=js"

import "./ProjectAnalysisTextTheme.vue?vue&type=style&index=0&id=058edbc4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058edbc4"]])

export default __exports__